// client/src/services/peDbTest.ts
// Calls the admin-only /api/pe-db-test endpoint to probe a direct connection
// to the Practice Engine SQL database.

export type PeDbTestResponse = {
  ok: boolean;
  elapsedMs: number;
  server: string;
  database: string;
  user: string;
  query: string;
  rowCount?: number;
  rows?: any[];
  error?: string;
  code?: string;
  sqlNumber?: number;
  sqlState?: number;
  sqlClass?: number;
  sqlLineNumber?: number;
  sqlServerName?: string;
  sqlProcName?: string;
  errorChain?: any[];
  errorInspected?: string;
  envCheck?: {
    PE_SQL_SERVER?: boolean;
    PE_SQL_SERVER_value?: string | null;
    PE_SQL_DATABASE?: boolean;
    PE_SQL_DATABASE_value?: string | null;
    PE_SQL_USER?: boolean;
    PE_SQL_USER_value?: string | null;
    PE_SQL_PASSWORD_present?: boolean;
    PE_SQL_PASSWORD_length?: number;
    PE_SQL_PASSWORD_preview?: string | null;
  };
  tokenClaims?: {
    aud?: string;
    iss?: string;
    tid?: string;
    appid?: string;
    appidacr?: string;
    upn?: string;
    unique_name?: string;
    ver?: string;
    scp?: string;
    iat?: number;
    exp?: number;
    nbf?: number;
  } | null;
  tokenError?: string | null;
};

export async function runPeDbTest(sqlText?: string): Promise<PeDbTestResponse> {
  const init: RequestInit = {
    method: sqlText ? 'POST' : 'GET',
    credentials: 'include',
    cache: 'no-store',
  };
  if (sqlText) {
    init.headers = { 'content-type': 'application/json' };
    init.body = JSON.stringify({ sql: sqlText });
  }

  const resp = await fetch('/api/pe-db-test', init);
  const text = await resp.text();

  let parsed: PeDbTestResponse | null = null;
  try {
    parsed = text ? (JSON.parse(text) as PeDbTestResponse) : null;
  } catch {
    parsed = null;
  }

  if (!parsed) {
    return {
      ok: false,
      elapsedMs: 0,
      server: '',
      database: '',
      user: '',
      query: sqlText || '',
      error: `Non-JSON response (HTTP ${resp.status}): ${text.slice(0, 200)}`,
    };
  }

  return parsed;
}
